import { Link } from 'react-router-dom';
import type { ModuleDefinition } from './registry';
export default function ModulePage({ module }: { module: ModuleDefinition }) {
  return <section className="p-8 space-y-4">
    <h1 className="text-2xl font-bold">{module.name}</h1>
    <p role="status">Estado: {module.status}</p>
    <p>Este módulo todavía no está implementado. No hay datos ni operaciones conectadas.</p>
    {module.id === 'ai' && <p>Nexus Core: orquestador de Nexus: agentes, skills, MCP, tools, integraciones y automatizaciones.</p>}
    <Link className="text-primary" to="/dashboard">Volver al Dashboard</Link>
  </section>;
}
